// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2QhZA","left":"StickyBox_left__3I_vr","right":"StickyBox_right__tZzZG"};